(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("simple-chat-widget", [], factory);
	else if(typeof exports === 'object')
		exports["simple-chat-widget"] = factory();
	else
		root["simple-chat-widget"] = factory();
})(this, function() {
return 